// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2bLkS","backBtn":"styles_backBtn__3NZHd"};